export const stepItemToText = (item) => {
  if (item == null) return '';
  if (typeof item === 'string') return item;
  if (typeof item !== 'object') return String(item);
  return item.description || item.text || item.selector || item.action || JSON.stringify(item);
};

export const stepsToText = (value) => {
  if (!value) return '';
  if (Array.isArray(value)) return value.map(stepItemToText).filter(Boolean).join('\n');
  if (typeof value === 'string') return value;
  if (typeof value === 'object') return stepItemToText(value);
  return String(value);
};
